import { useFormik } from 'formik';
import {
  ConfirmationModal,
  ErrorMessage,
  TextInput,
  useAlert,
} from '@employ-engage/common-components';
import { useState } from 'react';
import classNames from 'classnames';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteAccountFormProps {}

export function DeleteAccountForm(props: DeleteAccountFormProps) {
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const { t } = useTranslation(['common']);
  const { Alert: AccountDeletedAlert } = useAlert({
    type: 'success',
    title: t('Saved'),
    message: t('Your account has been deleted.'),
  });
  const { Alert: UnableToDeleteAccountAlert } = useAlert({
    type: 'error',
    title: t('Saved'),
    message: t('Your account could not be deleted...please try again.'),
  });
  const { Alert: IncorrectPasswordAlert } = useAlert({
    type: 'error',
    title: t('Something went wrong'),
    message: t('Your entered the wrong password...please try again.'),
  });
  const {
    handleSubmit,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    dirty,
  } = useFormik({
    initialValues: {
      currentPassword: '',
    },
    onSubmit: (values) => {
      setOpenConfirmationModal(true);
    },
    validationSchema: Yup.object().shape({
      currentPassword: Yup.string().required(t('Required')),
    }),
  });

  const confirmDeleteAccount = () => {
    // const auth = getAuth();
    // const user = auth.currentUser;

    // if (user) {
    //   signInWithEmailAndPassword(auth, user.email || '', values.currentPassword)
    //     .then((auth) => {
    //       deleteUser(auth.user)
    //         .then(() => {
    //           fireAccountDeletedAlert(3000);
    //           navigate('/');
    //         })
    //         .catch((error) => {
    //           console.error(error);
    //           fireUnableToDeleteAccountAlert(3000);
    //         });
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //       fireIncorrectPasswordAlert(3000);
    //     });
    // }
  };

  const isSubmitDisabled = Object.keys(errors).length > 0 || !dirty;

  return (
    <form className="md:col-span-2" onSubmit={handleSubmit}>
      <div className="col-span-full">
        <label
          htmlFor="currentPassword"
          className="block text-sm font-medium leading-6 text-light-primaryText"
        >
          {t('Current password')}
        </label>
        <div className="mt-2">
          <TextInput
            id="currentPassword"
            type="password"
            value={values.currentPassword}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </div>
        <ErrorMessage
          errors={errors.currentPassword}
          touched={touched.currentPassword}
        />
      </div>
      <div className="mt-8 flex">
        <button
          type="submit"
          className={classNames(
            'rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400',
            {
              'opacity-50 cursor-not-allowed': isSubmitDisabled,
            }
          )}
          disabled={isSubmitDisabled}
        >
          {t('Yes, delete my account')}
        </button>
      </div>
      <ConfirmationModal
        text={t(
          'Are you sure you want to delete your account?  This action cannot be undone!'
        )}
        open={openConfirmationModal}
        setOpen={setOpenConfirmationModal}
        onConfirm={confirmDeleteAccount}
        onCancel={() => setOpenConfirmationModal(false)}
      />
      <AccountDeletedAlert />
      <UnableToDeleteAccountAlert />
      <IncorrectPasswordAlert />
    </form>
  );
}

export default DeleteAccountForm;
